"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/ag-charts-locale/src/zh-CN.ts
var zh_CN_exports = {};
__export(zh_CN_exports, {
  AG_CHARTS_LOCALE_ZH_CN: () => AG_CHARTS_LOCALE_ZH_CN
});
module.exports = __toCommonJS(zh_CN_exports);
var AG_CHARTS_LOCALE_ZH_CN = {
  ariaAnnounceChart: "\u56FE\u8868\uFF0C\u5171\u6709${seriesCount}[number]\u4E2A\u7CFB\u5217",
  ariaAnnounceFlowProportionLink: "\u94FE\u63A5 ${index} \u603B\u5171 ${count}\uFF0C\u4ECE ${from} \u5230 ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u8282\u70B9 ${index} \u4E4B ${count}, ${description}",
  ariaAnnounceGaugeChart: "\u4EEA\u8868\u76D8\u56FE\u8868, ${caption}",
  ariaAnnounceHierarchyChart: "\u5C42\u6B21\u56FE\u8868, ${caption}",
  ariaAnnounceHierarchyDatum: "\u7EA7\u522B ${level}[number], ${count}[number] \u5B50\u9879, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "\u6309\u7A7A\u683C\u952E\u6216\u56DE\u8F66\u952E\u5207\u6362\u53EF\u89C1\u6027",
  ariaLabelAddHorizontalLine: "\u6DFB\u52A0\u6C34\u5E73\u7EBF",
  ariaLabelAnnotationOptionsToolbar: "\u6CE8\u91CA\u9009\u9879",
  ariaLabelAnnotationSettingsDialog: "\u6CE8\u91CA\u8BBE\u7F6E",
  ariaLabelColorPicker: "\u989C\u8272\u9009\u62E9\u5668",
  ariaLabelFinancialCharts: "\u8D22\u52A1\u56FE\u8868",
  ariaLabelLegend: "\u56FE\u4F8B",
  ariaLabelLegendItem: "${label}, \u56FE\u4F8B\u9879 ${index}[number] / ${count}[number]",
  ariaLabelLegendItemUnknown: "\u672A\u77E5\u56FE\u4F8B\u9879\u76EE",
  ariaLabelLegendPageNext: "\u4E0B\u4E00\u9875\u56FE\u4F8B",
  ariaLabelLegendPagePrevious: "\u4E0A\u4E00\u4F20\u5947\u9875\u9762",
  ariaLabelLegendPagination: "\u56FE\u4F8B\u5206\u9875",
  ariaLabelNavigator: "\u5BFC\u822A\u5668",
  ariaLabelNavigatorMaximum: "\u6700\u5927\u503C",
  ariaLabelNavigatorMinimum: "\u6700\u5C0F\u503C",
  ariaLabelNavigatorRange: "\u8303\u56F4",
  ariaLabelRangesToolbar: "\u8303\u56F4",
  ariaLabelSettingsTabBar: "\u8BBE\u7F6E",
  ariaLabelZoomToolbar: "\u7F29\u653E",
  ariaValuePanRange: "${min}[percent0to2dp] \u81F3 ${max}[percent0to2dp]",
  contextMenuDownload: "\u4E0B\u8F7D",
  contextMenuPanToCursor: "\u5E73\u79FB\u5230\u6B64\u5904",
  contextMenuToggleOtherSeries: "\u5207\u6362\u5176\u4ED6\u7CFB\u5217",
  contextMenuToggleSeriesVisibility: "\u5207\u6362\u53EF\u89C1\u6027",
  contextMenuZoomToCursor: "\u7F29\u653E\u5230\u6B64\u5904",
  dialogHeaderChannel: "\u9891\u9053",
  dialogHeaderDatePriceRange: "\u65E5\u671F\u548C\u4EF7\u683C",
  dialogHeaderDateRange: "\u65E5\u671F\u8303\u56F4",
  dialogHeaderFibonacciRange: "\u6590\u6CE2\u90A3\u5951\u56DE\u64A4",
  dialogHeaderLine: "\u7EBF",
  dialogHeaderPriceRange: "\u4EF7\u683C\u8303\u56F4",
  dialogHeaderText: "\u6587\u5B57",
  dialogInputAlign: "\u5BF9\u9F50",
  dialogInputColorPicker: "\u989C\u8272",
  dialogInputColorPickerAltText: "\u6587\u5B57\u989C\u8272",
  dialogInputExtendAbove: "\u6269\u5C55\u4EE5\u4E0A",
  dialogInputExtendBelow: "\u5411\u4E0B\u6269\u5C55",
  dialogInputExtendChannelEnd: "\u6269\u5C55\u901A\u9053\u7EC8\u70B9",
  dialogInputExtendChannelStart: "\u5EF6\u957F\u901A\u9053\u5F00\u59CB",
  dialogInputExtendLeft: "\u5411\u5DE6\u5EF6\u4F38",
  dialogInputExtendLineEnd: "\u5EF6\u957F\u7EBF\u7AEF",
  dialogInputExtendLineStart: "\u5EF6\u957F\u7EBF\u8D77\u70B9",
  dialogInputExtendRight: "\u5411\u53F3\u5EF6\u4F38",
  dialogInputFibonacciBands: "\u6CE2\u6BB5",
  dialogInputFibonacciBandsAltText: "\u6590\u6CE2\u90A3\u5951\u6CE2\u6BB5",
  dialogInputFillColorPicker: "\u586B\u5145",
  dialogInputFillColorPickerAltText: "\u586B\u5145\u989C\u8272",
  dialogInputFontSize: "\u5927\u5C0F",
  dialogInputFontSizeAltText: "\u5B57\u4F53\u5927\u5C0F",
  dialogInputLineStyle: "\u865A\u7EBF",
  dialogInputPosition: "\u4F4D\u7F6E",
  dialogInputReverse: "\u53CD\u8F6C",
  dialogInputShowFill: "\u663E\u793A\u586B\u5145",
  dialogInputStrokeWidth: "\u2018\u7C97\u7EC6\u2019",
  dialogInputStrokeWidthAltText: "\u2018\u7EBF\u6761\u7C97\u7EC6\u2019",
  iconAltTextAlignCenter: "\u5C45\u4E2D",
  iconAltTextAlignLeft: "\u5C45\u5DE6",
  iconAltTextAlignRight: "\u53F3\u5BF9\u9F50",
  iconAltTextClose: "\u2018\u5173\u95ED\u2019",
  iconAltTextLineStyleDashed: "\u957F\u865A\u7EBF",
  iconAltTextLineStyleDotted: "\u77ED\u865A\u7EBF",
  iconAltTextLineStyleSolid: "\u5B9E\u7EBF",
  iconAltTextPositionBottom: "\u5E95\u90E8",
  iconAltTextPositionCenter: "\u5C45\u4E2D",
  iconAltTextPositionTop: "\u9876\u90E8",
  inputTextareaPlaceholder: "\u6DFB\u52A0\u6587\u5B57",
  measurerDateRangeBars: "${value}[number] \u6761",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "\u4F53\u79EF ${value}",
  overlayLoadingData: "\u6B63\u5728\u52A0\u8F7D\u6570\u636E...",
  overlayNoData: "\u6CA1\u6709\u6570\u636E\u663E\u793A",
  overlayNoVisibleSeries: "\u6CA1\u6709\u53EF\u89C1\u7684\u7CFB\u5217",
  overlayUnsupportedBrowser: "\u4E0D\u517C\u5BB9\u7684\u6D4F\u89C8\u5668\u7248\u672C\u3002\u8BF7\u5347\u7EA7\u60A8\u7684\u6D4F\u89C8\u5668\u3002",
  seriesHistogramTooltipCount: "${yName} (\u8BA1\u6570)",
  seriesHistogramTooltipFrequency: "\u9891\u7387",
  seriesHistogramTooltipMean: "${yName} (\u5E73\u5747\u503C)",
  seriesHistogramTooltipSum: "${yName} (\u603B\u548C)",
  toolbarAnnotationsArrow: "\u7BAD\u5934",
  toolbarAnnotationsArrowDown: "\u7BAD\u5934\u5411\u4E0B",
  toolbarAnnotationsArrowUp: "\u5411\u4E0A\u7BAD\u5934",
  toolbarAnnotationsCallout: "\u6807\u6CE8",
  toolbarAnnotationsClearAll: "\u6E05\u9664\u6240\u6709",
  toolbarAnnotationsComment: "\u8BC4\u8BBA",
  toolbarAnnotationsDatePriceRange: "\u65E5\u671F\u548C\u4EF7\u683C",
  toolbarAnnotationsDateRange: "\u65E5\u671F\u8303\u56F4",
  toolbarAnnotationsDelete: "\u5220\u9664",
  toolbarAnnotationsDisjointChannel: "\u72EC\u7ACB\u901A\u9053",
  toolbarAnnotationsDragHandle: "\u201C\u62D6\u52A8\u5DE5\u5177\u680F\u201D",
  toolbarAnnotationsFibonacciAnnotations: "\u6590\u6CE2\u90A3\u5951",
  toolbarAnnotationsFibonacciRetracement: "\u6590\u6CE2\u90A3\u5951\u56DE\u64A4",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u57FA\u4E8E\u8D8B\u52BF\u7684\u6590\u6CE2\u7EB3\u5951",
  toolbarAnnotationsFillColor: "\u586B\u5145\u989C\u8272",
  toolbarAnnotationsHorizontalLine: "\u6C34\u5E73\u7EBF",
  toolbarAnnotationsLineAnnotations: "\u8D8B\u52BF\u7EBF",
  toolbarAnnotationsLineColor: "\u7EBF\u6761\u989C\u8272",
  toolbarAnnotationsLineStrokeWidth: "\u7EBF\u6761\u5BBD\u5EA6",
  toolbarAnnotationsLineStyle: "\u7EBF\u6761\u6837\u5F0F",
  toolbarAnnotationsLock: "\u9501\u5B9A",
  toolbarAnnotationsMeasurerAnnotations: "\u6D4B\u91CF\u5DE5\u5177",
  toolbarAnnotationsNote: "\u6CE8\u91CA",
  toolbarAnnotationsParallelChannel: "\u5E73\u884C\u901A\u9053",
  toolbarAnnotationsPriceRange: "\u4EF7\u683C\u8303\u56F4",
  toolbarAnnotationsQuickDatePriceRange: "\u6D4B\u91CF",
  toolbarAnnotationsSettings: "\u8BBE\u7F6E",
  toolbarAnnotationsShapeAnnotations: "\u7BAD\u5934",
  toolbarAnnotationsText: "\u6587\u672C",
  toolbarAnnotationsTextAnnotations: "\u6587\u672C\u6807\u6CE8",
  toolbarAnnotationsTextColor: "\u5B57\u4F53\u989C\u8272",
  toolbarAnnotationsTextSize: "\u6587\u5B57\u5927\u5C0F",
  toolbarAnnotationsTrendLine: "\u8D8B\u52BF\u7EBF",
  toolbarAnnotationsUnlock: "\u89E3\u9501",
  toolbarAnnotationsVerticalLine: "\u5782\u76F4\u7EBF",
  toolbarRange1Month: "1\u4E2A\u6708",
  toolbarRange1MonthAria: "1\u4E2A\u6708",
  toolbarRange1Year: "1\u5E74",
  toolbarRange1YearAria: "1\u5E74",
  toolbarRange3Months: "3\u4E2A\u6708",
  toolbarRange3MonthsAria: "3\u4E2A\u6708",
  toolbarRange6Months: "6\u6708",
  toolbarRange6MonthsAria: "6\u4E2A\u6708",
  toolbarRangeAll: "\u5168\u90E8",
  toolbarRangeAllAria: "\u5168\u90E8",
  toolbarRangeYearToDate: "\u5E74\u521D\u81F3\u4ECA",
  toolbarRangeYearToDateAria: "\u5E74\u521D\u81F3\u4ECA",
  toolbarSeriesTypeCandles: "\u8721\u70DB\u56FE",
  toolbarSeriesTypeDropdown: "\u56FE\u8868\u7C7B\u578B",
  toolbarSeriesTypeHighLow: "\u9AD8\u4F4E",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\u7A7A\u5FC3\u8721\u70DB",
  toolbarSeriesTypeLine: "\u7EBF",
  toolbarSeriesTypeLineWithMarkers: "\u5E26\u6807\u8BB0\u7684\u6298\u7EBF\u56FE",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\u9636\u68AF\u7EBF",
  toolbarZoomPanEnd: "\u79FB\u81F3\u7ED3\u5C3E",
  toolbarZoomPanLeft: "\u5411\u5DE6\u79FB\u52A8",
  toolbarZoomPanRight: "\u5411\u53F3\u5E73\u79FB",
  toolbarZoomPanStart: "\u5E73\u79FB\u5230\u5F00\u59CB\u4F4D\u7F6E",
  toolbarZoomReset: "\u91CD\u7F6E\u7F29\u653E",
  toolbarZoomZoomIn: "\u653E\u5927",
  toolbarZoomZoomOut: "\u7F29\u5C0F",
  tooltipPaginationStatus: "${index}[number] / ${count}[number]"
};
//# sourceMappingURL=zh-CN.cjs.js.map
